import { createReducer } from 'typesafe-actions';

import { setIsLoadingAction } from './actions';
import { Resource } from './types';
import type { LoadingAction, LoadingState } from './types';

const populateIsLoadingByResource = () =>
  Object.keys(Resource).reduce((accum, resource) => {
    accum[resource as Resource] = false;

    return accum;
  }, {} as Record<Resource, boolean>);

export const initialLoadingState: LoadingState = {
  isLoadingByResource: populateIsLoadingByResource(),
};

export const loadingReducer = createReducer<LoadingState, LoadingAction>(
  initialLoadingState
).handleAction(
  setIsLoadingAction,
  (state, { payload: [resource, isLoading] }) => {
    return {
      ...state,
      isLoadingByResource: {
        ...state.isLoadingByResource,
        [resource]: isLoading,
      },
    };
  }
);
